var map = {
	"./baac.svg": 614,
	"./bay.svg": 615,
	"./bbl.svg": 616,
	"./bnp.svg": 617,
	"./boa.svg": 618,
	"./cacib.svg": 619,
	"./cimb.svg": 620,
	"./citi.svg": 621,
	"./db.svg": 622,
	"./ghb.svg": 623,
	"./gsb.svg": 624,
	"./hsbc.svg": 625,
	"./ibank.svg": 626,
	"./icbc.svg": 627,
	"./jpm.svg": 628,
	"./kbank.svg": 629,
	"./kk.svg": 630,
	"./ktb.svg": 631,
	"./lhb.svg": 632,
	"./mb.svg": 633,
	"./mega.svg": 634,
	"./mufg.svg": 635,
	"./rbs.svg": 636,
	"./sc.svg": 637,
	"./scb.svg": 638,
	"./smbc.svg": 639,
	"./tbank.svg": 640,
	"./tcrb.svg": 641,
	"./tisco.svg": 642,
	"./tmb.svg": 643,
	"./uob.svg": 644
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thaibank ^\.\/.*\.svg$
// module id = 75
// module chunks = 1